// Note: This example requires that you consent to location sharing when
// prompted by your browser. If you see the error "The Geolocation service
// failed.", it means you probably did not give permission for the browser to
// locate you.
let map, infoWindow;
let inputFilled = {
  from: false,
  to: false,
};

function initMap() {
  let options = {
    // componentRestrictions: { country: ['fr', 'es', 'it', 'be', 'de'] },
    componentRestrictions: { country: ['fr'] },
  };
  let fromPlacesElement = document.getElementById('from_places');
  let from_places = new google.maps.places.Autocomplete(
    fromPlacesElement,
    options
  );
  let toPlacesElement = document.getElementById('to_places');
  let to_places = new google.maps.places.Autocomplete(toPlacesElement, options);

  from_places.addListener('place_changed', () => {
    let from_place = from_places.getPlace();
    let from_address = from_place.formatted_address;
    document.getElementById('origin').value = from_address;
    if (from_address) {
      inputFilled.from = true;
      if (inputFilled.to && validationButton.disabled) {
        validationButton.disabled = false;
      }
    }
  });

  to_places.addListener('place_changed', () => {
    let to_place = to_places.getPlace();
    let to_address = to_place.formatted_address;
    if (to_address) {
      inputFilled.to = true;
      if (inputFilled.from && validationButton.disabled) {
        validationButton.disabled = false;
      }
    }
    document.getElementById('destination').value = to_address;
  });
}

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
  infoWindow.setPosition(pos);
  infoWindow.setContent(
    browserHasGeolocation
      ? 'Geolocalisation non autorisée sur votre appareil'
      : "Error: Your browser doesn't support geolocation."
  );
  infoWindow.open(map);
}

function user() {
  if (navigator.geolocation) {
    //check if geolocation is available

    navigator.geolocation.getCurrentPosition(
      (p) => {
        showPosition(p);
      },
      (error) => {
        if (error.code === 1) {
          alert(
            `Pour utiliser cette votre position merci d'activer la géolocalisation.\nSi vous utiliser Chrome, en haut à droite de la barre d'adresse cliquez sur les 3 petits points puis accéder aux "Paramètres".\nCliquez sur "Paramètres de site" puis "Position" .\nActivez la "Position".`
          );
        }
      }
    );
  } else {
    alert(
      'Votre navigateur ne supporte pas la géolocalisation... Mettez le à jour ou alors changez-en pour utiliser cette fonctionnalité'
    );
  }
}

function showPosition(position) {
  document.querySelector('.myForm input[name = "latitude"]').value =
    position.coords.latitude;
  document.querySelector('.myForm input[name = "longitude"]').value =
    position.coords.longitude;

  const LAT = position.coords.latitude;
  const LNG = position.coords.longitude;
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ location: { lat: LAT, lng: LNG } }, (results, status) => {
    if (status === 'OK') {
      if (results[0]) {
        let address = results[0].formatted_address;
        document.getElementById('from_places').value = address;
        document.getElementById('origin').value = address;
        inputFilled.from = true;
        if (inputFilled.to && validationButton.disabled) {
          validationButton.disabled = false;
        }
      } else {
        window.alert('No results found');
      }
    } else {
      window.alert('Geocoder failed due to: ' + status);
    }
  });
  // let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${LAT},${LNG}&key=${KEY}`;
  // fetch(url)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     let parts = data.results[0].address_components;
  //     let address = data.results[0].formatted_address;
  //     document.getElementById('from_places').value = address;
  //     document.getElementById('origin').value = address;
  //     //document.getElementById('from_places').value.style.fontsize = '30px';

  //     inputFilled.from = true;
  //     if (inputFilled.to && validationButton.disabled) {
  //       validationButton.disabled = false;
  //     }
  //   })
  //   .catch((err) => console.warn(err.message));
}
